import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { checkFP, menuLoginPhone, ugiftPath } from "./config/config";
import { PC_Browser_Guard } from "./shared/services/interceptors/pc-browser-guard";
import { DetectBrowser } from "./shared/layouts/detect-browser/detect-browser.component";
import { DetectBrowserAndroid } from "./shared/layouts/detect-browser-android/detect-browser.component";
import { DetectBrowserIphone } from "./shared/layouts/detect-browser-iphone/detect-browser.component";

const routes: Routes = [
  {
    path: "login-phone",
    loadChildren: () =>
      import("./login-phone/login-phone.module").then(
        (m) => m.LoginPhoneModule
      ),
    canActivate: [PC_Browser_Guard],
  },
  {
    path: ugiftPath.browser.route,
    component: DetectBrowser,
  },
  {
    path: checkFP.path,
    loadChildren: () =>
      import("./check-fp/check-fp.module").then((m) => m.CheckFPModule),
  },
  {
    path: ugiftPath.browserAndroid.route,
    component: DetectBrowserAndroid,
  },
  {
    path: ugiftPath.browserIphone.route,
    component: DetectBrowserIphone,
  },
  {
    path: "**",
    redirectTo: menuLoginPhone.path,
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: "legacy",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
